import firebase from "firebase/app";
import "firebase/firestore";

import { AppThunk } from "services/redux/rootReducer";
import { ArticleAction } from "../../types/actions";
import { Article } from "../../types/article";

const getAllArticles = (): AppThunk<() => void> => (dispatch) => {
    const unsubscribe = firebase
        .firestore()
        .collection("articles")
        .onSnapshot((querySnapshot) => {
            const articles: Article[] = [];
            querySnapshot.forEach((doc: firebase.firestore.DocumentData) => {
                articles.push(doc.data());
            });
            dispatch({
                type: ArticleAction.SET_ARTICLES,
                articles,
            });
        });

    return unsubscribe;
};

export default getAllArticles;
